import React from 'react'
import { styled } from '../../stitches.config';

const BridText = props => {
    const { article } = props;

    return (
        <React.Fragment>
            <Title>{article.title}</Title>
            <Sub>{article.label}</Sub>
        </React.Fragment>
    )
}

const Title = styled("h2", {
    margin: "20px",
    fontFamily: "$grotesk",
    fontWeight: 900,
    fontSize: "22px",
    textAlign: "center",
    color: "$grayscale100",
    "@media (min-width: 992px)": {
        margin: "20px auto",
        width: "760px",
        fontSize: "35px",
        paddingTop: "0px",
        marginBottom: "30px"
    }
});
const Sub = styled("p", {
    margin: "0 20px",
    fontFamily: "$grotesk",
    fontSize: "14px",
    fontWeight: 300,
    textAlign: "center",
    color: "$grayscale100",
    "@media (min-width: 992px)": {
        margin: "0 auto 20px auto",
        width: "539px",
        fontSize: "18px",
        marginBottom: "35px"
    }
});

export default BridText